/**
 * Visible copy for one Hubwayz room card.
 * Board and cancellation stay. The gray line that repeated board + capacity does not.
 */

function trimText(value) {
  const text = String(value || "").trim();
  return text || "";
}

export function hubwayzRoomCardCopy(room) {
  const board = trimText(room?.boardSummary || room?.boardLabel);
  const cancellation = trimText(
    room?.cancellationSummary ||
      (room?.cancellation ? room.cancellation.type : "")
  );
  const capacity = trimText(room?.capacityLabel);
  const duplicateNote = [board, capacity].filter(Boolean).join(" · ");
  const cancellationWarn =
    room?.cancellationMixed === true ||
    (room?.cancellationFree !== true && room?.cancellationFullyRefundable === false);

  return {
    board: board || null,
    boardWarn: room?.boardMixed === true,
    cancellation: cancellation || null,
    cancellationWarn,
    confirmLabel: room?.immediateConfirm ? "אישור מיידי" : "ממתין לאישור",
    note: null,
    omittedDuplicateNote: duplicateNote || null,
  };
}
